/* スーパー玄米ラテ LP — 操作部分・表示補助
 * - FAQ: 開閉のみ（回答は未設定）
 * - 管理栄養士の声: ループ用の複製と、クリックで全文を出すモーダル
 * - 表示演出: スクロールで各まとまりをフェードイン（.rv / .is-in）
 * - 追従 CTA: スクロール中に画面下から表示、止まると消える（.float-cta / .is-shown）
 * - 購入ボタン: Shopify では #genmai-lp[data-variant-id] の商品を /cart/add.js で数量ぶんカートに入れ、カート（または購入手続き）へ移動。
 *   variant が無い（ローカル確認・商品未設定）ときは data-purchase-url があればそこへ、無ければ遷移しない
 * - 個数: 数量の選択は無し。#genmai-lp[data-quantity] の個数（最低注文個数。既定 2）をカートに入れる
 * - 表示補助: 1040〜1299px は 1300px キャンバスを縮小表示（本文 12px 以上を保てる範囲）、1039px 以下は 402px キャンバス（.lp）を
 *   画面幅に拡縮（最大 1.4 倍。タブレットでは中央の 1 列）し、
 *   流し込み部分の .grp.widget は幅に合わせて zoom（--fit で割合指定、none で無効）
 */
(function () {
  'use strict';

  // アコーディオン（FAQ・商品情報）: grid-template-rows の遷移で滑らかに開閉
  document.querySelectorAll('.faq-q, .pinfo-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(!expanded));
      if (panel) panel.classList.toggle('is-open', !expanded);
    });
  });

  // FAQ・商品情報（PC・タブレット）: 1300px キャンバスは絶対配置なので、開いて伸びた分（--faq-x / --pinfo-x）だけ
  // 下のセクション・背景帯とキャンバスの高さを下げる（layout.css / style.css の calc で使う）
  var pageEl = document.querySelector('.page');
  // 伸びた分 = 開いている回答欄（.acc-panel、閉じていると高さ 0）の高さの合計。基準の高さを持たないので、
  // 開いたまま画面幅を変えても正しい（以前は幅を変えると開いた状態を基準に取り直して重なっていた）
  [['.faq', '--faq-x'], ['.pinfo', '--pinfo-x']].forEach(function (spec) {
    var list = document.querySelector(spec[0]);
    if (!list || !pageEl || !('ResizeObserver' in window)) return;
    var panels = list.querySelectorAll('.acc-panel');
    var sync = function () {
      if (window.matchMedia('(max-width: 1039px)').matches) { pageEl.style.removeProperty(spec[1]); return; }
      var x = 0; panels.forEach(function (p) { x += p.offsetHeight; });
      pageEl.style.setProperty(spec[1], x + 'px');
    };
    var ro = new ResizeObserver(sync);
    ro.observe(list); panels.forEach(function (p) { ro.observe(p); });
    window.addEventListener('resize', sync);
  });

  // 管理栄養士の声: ループ用にカード 1 セットを 2 回複製（アニメーションは 1/3 ずつ送る）。複製は読み上げ・タブ移動の対象外
  document.querySelectorAll('.marquee-track').forEach(function (track) {
    var items = Array.prototype.slice.call(track.children);
    for (var k = 0; k < 2; k++) {
      items.forEach(function (li) {
        var c = li.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('button').forEach(function (b) { b.tabIndex = -1; });
        track.appendChild(c);
      });
    }
  });

  // 管理栄養士の声: クリック／タップで全文をモーダル表示（Esc・× ・背景クリックで閉じる）
  var modal = document.getElementById('voice-modal');
  if (modal && typeof modal.showModal === 'function') {
    var mTitle = modal.querySelector('.voice-modal-title');
    var mText = modal.querySelector('.voice-modal-text');
    var mIcon = modal.querySelector('.voice-modal-head > .voice-icon');
    var opener = null;
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('.voice-card');
      if (!card) return;
      opener = card;
      mTitle.textContent = card.querySelector('.voice-title').textContent;
      mText.textContent = card.querySelector('.voice-text').textContent;
      if (mIcon) mIcon.innerHTML = card.querySelector('.voice-icon').innerHTML;   // カードと同じアイコン
      modal.showModal();
      document.documentElement.classList.add('glp-modal-open');
    });
    modal.querySelector('.voice-modal-close').addEventListener('click', function () { modal.close(); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });   // 背景（::backdrop）クリック
    modal.addEventListener('close', function () {
      document.documentElement.classList.remove('glp-modal-open');
      if (opener && opener.tabIndex !== -1) opener.focus({ preventScroll: true });
    });
  }

  // さりげない表示演出: 各セクションの最上位のまとまり（.grp）を、画面に入ったときにフェードイン。
  // 同時に入ったものは上から順に 0.1 秒ずつずらす（最大 0.4 秒）。動きを減らす設定では何もしない
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !reduceMotion) {
    var revealTargets = document.querySelectorAll('main > .sec:not(.sec-header):not(.sec-footer) > .grp, main > .sec > .sub > .grp');
    var io = new IntersectionObserver(function (entries) {
      var shown = entries.filter(function (e) { return e.isIntersecting; })
        .sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left; });
      shown.forEach(function (e, i) {
        var g = e.target.__rvGroup || e.target;
        g.style.setProperty('--rv-delay', Math.min(i * 0.1, 0.4) + 's');
        g.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    Array.prototype.forEach.call(revealTargets, function (el) {
      el.classList.add('rv');
      // SP の原寸配置では .grp 自体の枠が 0×0 で、位置も画面外（親の overflow:hidden で切られる）になることがあるので、
      // 枠が無いまとまりは中の実際の画像・文字で判定する
      var probe = el;
      if (!el.offsetWidth || !el.offsetHeight) {
        var kids = el.querySelectorAll('img, .pic, .clip, .shape, p, h2, h3');
        for (var n = 0; n < kids.length; n++) { var r = kids[n].getBoundingClientRect(); if (r.width > 0 && r.height > 0) { probe = kids[n]; break; } }   // 表示されている子だけ
      }
      probe.__rvGroup = el;
      io.observe(probe);
    });
  }

  // 購入ボタン（Shopify のカートに直接追加。個数は data-quantity）
  var root = document.getElementById('genmai-lp');
  var variantId = root ? root.getAttribute('data-variant-id') : '';
  var available = !root || root.getAttribute('data-available') !== 'false';
  var addUrl = (root && root.getAttribute('data-cart-add-url')) || '/cart/add';
  var nextUrl = (root && root.getAttribute('data-next-url')) || '/cart';
  var qty = Math.max(1, parseInt(root && root.getAttribute('data-quantity'), 10) || 1);   // カートに入れる個数（Shopify のセクション設定。最低注文個数に合わせて既定 2）
  document.querySelectorAll('.btn-buy').forEach(function (a) {
    var label = a.querySelector('span');
    var original = label ? label.textContent : '';
    if (variantId && !available) { a.classList.add('is-soldout'); a.setAttribute('aria-disabled', 'true'); if (label) label.textContent = '売り切れ'; }
    a.addEventListener('click', function (e) {
      if (!variantId) {
        var url = a.getAttribute('data-purchase-url');
        if (!url) { e.preventDefault(); console.warn('カートに入れる商品が未設定です（Shopify のセクション設定）'); return; }
        a.setAttribute('href', url); return;
      }
      e.preventDefault();
      if (!available || a.classList.contains('is-loading')) return;
      a.classList.add('is-loading'); a.setAttribute('aria-busy', 'true');
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart/add ' + r.status);
        window.location.href = nextUrl;
      }).catch(function (err) {
        console.error(err);
        a.classList.remove('is-loading'); a.removeAttribute('aria-busy');
        if (label) { label.textContent = 'カートに追加できませんでした'; setTimeout(function () { label.textContent = original; }, 3000); }
      });
    });
  });

  // 追従 CTA: MV の購入ボタンを過ぎてから、スクロール中に表示（0.25 秒スクロールが続いたら出す）。
  // スクロールが止まって 2 秒で消す（ボタンにカーソル・フォーカスがある間は消さない）。
  // 商品カート・末尾のセクションが見えている間と、ページ最下部では出さない
  var floatCta = document.querySelector('.float-cta');
  if (floatCta) {
    // 判定はスクロールのたびに位置を直接見る（素早いスクロールやページ内リンクで MV のボタンを一度も表示せずに通り過ぎても正しく判定するため）
    var fvBuy = document.querySelector('.price-btn .btn-buy');
    var blockSecs = [document.getElementById('cart'), document.getElementById('closing')].filter(Boolean);
    var shownCta = false, showTimer = null, idleTimer = null;
    var inView = function (el) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; };
    var passedFv = function () { return !fvBuy || fvBuy.getBoundingClientRect().bottom < 0; };
    var nearBottom = function () { var de = document.documentElement; return window.innerHeight + window.scrollY >= de.scrollHeight - 120; };
    var canShow = function () { return passedFv() && !blockSecs.some(inView) && !nearBottom(); };
    var holding = function () { return floatCta.matches(':hover') || floatCta.contains(document.activeElement); };
    var setCta = function (v) {
      if (v === shownCta) return;
      shownCta = v;
      floatCta.classList.toggle('is-shown', v);
      floatCta.setAttribute('aria-hidden', String(!v));
      if (v) floatCta.removeAttribute('inert'); else floatCta.setAttribute('inert', '');
    };
    var armIdle = function () {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () { if (holding()) { armIdle(); return; } clearTimeout(showTimer); showTimer = null; setCta(false); }, 2000);
    };
    window.addEventListener('scroll', function () {
      if (!canShow()) { clearTimeout(showTimer); showTimer = null; setCta(false); return; }
      if (!shownCta && !showTimer) showTimer = setTimeout(function () { showTimer = null; if (canShow()) setCta(true); }, 250);
      armIdle();
    }, { passive: true });
  }

  // 画面幅に応じた縮小
  var page = document.querySelector('.page');
  function hostWidth() { return (page && page.parentElement && page.parentElement.clientWidth) || window.innerWidth; }   // LP を置いた入れ物の幅（スクロールバーを除く）
  var widgets = Array.prototype.slice.call(document.querySelectorAll('.grp.widget'));
  var mqSp = window.matchMedia('(max-width: 1039px)');
  var mqTab = window.matchMedia('(min-width: 1040px) and (max-width: 1299px)');

  function innerWidth(el) {
    var cs = getComputedStyle(el);
    return el.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
  }

  // 画面端に置く装飾（稲穂）: 1300px キャンバスの外側（viewport の左端）に配置。拡大はしない
  var edges = Array.prototype.slice.call(document.querySelectorAll('.edge-left, .edge-right'));
  edges.forEach(function (el) {
    var cs = getComputedStyle(el);
    el.dataset.left = parseFloat(cs.left); el.dataset.w = parseFloat(cs.width);
  });
  function placeEdges(zoom) {
    var canvasW = hostWidth() / zoom;           // キャンバス座標系での画面幅
    var over = Math.max(0, (canvasW - 1300) / 2);       // キャンバス外側の余白
    edges.forEach(function (el) {
      if (mqSp.matches) { el.style.transform = ''; return; }
      var w = parseFloat(el.dataset.w), left = parseFloat(el.dataset.left);
      var dx = el.classList.contains('edge-left') ? -over - left : (1300 + over) - (left + w);
      el.style.transform = 'translateX(' + dx + 'px)';
    });
  }

  // スマホ・タブレット: 402px の原寸キャンバス（.lp）を画面幅に合わせて拡縮（Figma「iPhone 17 - 1」基準）。
  // 最大 1.4 倍で止めて中央に置く（それ以上だと文字・写真が大きすぎ、写真もぼやける）
  var SP_MAX_ZOOM = 1.4;
  var lp = document.querySelector('.lp');

  function fit() {
    // タブレット: PC デザインを等倍縮小
    var zoom = mqTab.matches ? hostWidth() / 1300 : 1;
    page.style.zoom = mqTab.matches ? String(zoom) : '';
    placeEdges(zoom);
    lp.style.zoom = mqSp.matches ? String(Math.min(hostWidth() / 402, SP_MAX_ZOOM)) : '';

    // スマホ: 組み合わせ要素を親幅に合わせて縮小
    widgets.forEach(function (w) {
      if (!mqSp.matches) { w.style.zoom = ''; return; }
      var base = parseFloat(w.getAttribute('data-w')) || 1;
      var parent = w.parentElement;
      var avail = innerWidth(parent);
      if (parent.classList.contains('row')) {
        var cs = getComputedStyle(parent);
        var cols = parseInt(cs.getPropertyValue('--cols'), 10) || 1;
        var gap = parseFloat(cs.columnGap || cs.gap) || 0;
        avail = (avail - gap * (cols - 1)) / cols;
      }
      // --fit（mobile.css で指定）: 親幅に対する割合。none なら zoom せず CSS の流し込みに任せる
      var fitv = getComputedStyle(w).getPropertyValue('--fit').trim();
      if (fitv === 'none') { w.style.zoom = ''; return; }
      var fit = parseFloat(fitv) || 1;
      var minz = parseFloat(w.getAttribute('data-minz')) || 0;
      w.style.zoom = String(Math.max(minz, Math.min(1, avail * fit / base)));
    });
  }

  fit();
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
})();
